import styled from 'styled-components';
import theme from "../../constants/theme";

export const Wrapper = styled.div`
	margin-top: 4rem;
`;

export const Info = styled.p`
	margin: 1.5rem 0;
	color: ${theme.colors.grayDarker};
`;
